<template>
  <article class="fullpage">
    <overview />
  </article>
</template>

<script>
import { overview } from '@/components/advisor';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  head() {
    const title = this.$t('Overview');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },
  components: { overview },
};
</script>
